import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ImportDetailModel } from '@app/core/models/imports/import-detail.model';
import { ImportModel } from '@app/core/models/imports/import.model';
import { FileDownloadService } from '@app/core/services/filedownload.service';
import { ImportService } from '@app/core/services/import.service';
import { ModalComponent } from '@app/shared/components/modal/modal.component';
import { ModalHelper } from '@app/shared/models/modal-helper.model';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-import-detail-modal',
  templateUrl: './import-detail-modal.component.html',
  styleUrls: ['./import-detail-modal.component.scss'],
})
export class ImportDetailModalComponent {
  import: ImportModel;
  detail: ImportDetailModel;
  unsubscribe$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private dialogRef: MatDialogRef<ImportDetailModalComponent>,
    public dialog: MatDialog,
    private importService: ImportService,
    private fileDownloadService: FileDownloadService,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.import = data.Import;
    this.detail = data.Detail;
  }

  close() {
    this.dialogRef.close();
  }

  onPdf = () => {
    this.importService
      .getImportDetailPdfContent(this.import.Id, this.detail.Id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (blobData: Blob) => {
          this.fileDownloadService.downloadBlob(
            blobData,
            this.detail.PdfFileName,
            'application/pdf'
          );
        },
        (_) => {
          const modalErreurConfig = new ModalHelper().getAlertConfig(
            `Une erreur est survenue lors du téléchargement.`
          );
          this.dialog.open(ModalComponent, modalErreurConfig);
        }
      );
  };
}
